const handlerSubmitInput = () => {
  const submitBtn = $('.auth-form__button--submit');
  const userCPF = $('#user_cpf');

  submitBtn.attr('disabled', 'true');

  userCPF.on('change', () => {
    submitBtn.removeAttr('disabled');
  });
};

export default handlerSubmitInput;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/auth/handlerSubmitInput.js